export interface ChargeOnCompanyMappingEntity {

    id?: number | null,
    priority?: number | null,
    tempPriority?: number | null,
    mappingType: string,
    chargeType?: string | null,
    subChargeType?: string | null,
    soa?: string | null,
    owner?: string | null,
    forwarderCode?: string | null,
    forwarderReference?: string | null,
    vesselType?: string | null,
    chargeCode?: string | null,
    operatingTml?: string | null,
    consortiumCode?: string | null,
    serviceCode?: string | null,
    cntrStatus?: string | null,
    chargeOnCompanyCode?: string | null,
    activeInd?: string | null,

    [key: string]: string | boolean | null | Object | undefined
}
export const EMPTY_CHARGE_ON_COMPANY_MAPPING_ENTITY: ChargeOnCompanyMappingEntity = {
    id: 0,
    priority: null,
    tempPriority: null,
    chargeType: null,
    subChargeType: null,
    soa: null,
    owner: null,
    forwarderCode: null,
    forwarderReference: null,
    vesselType: null,
    chargeCode: null,
    operatingTml: null,
    consortiumCode: null,
    serviceCode: null,
    cntrStatus: null,
    chargeOnCompanyCode: null,
    activeInd: 'Y',
    mappingType: "ChargeOnCompanyMappingEntity",
}